


// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/esm/Row';
// import { DeveloperTable } from './DeveloperTable';
// import Table from 'react-bootstrap/esm/Table';
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
// import AddIcon from '@mui/icons-material/Add';
// import { Snackbar, Alert, useMediaQuery, TextField, MenuItem, Box } from '@mui/material';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { Col, Spinner } from 'react-bootstrap';
// import moment from 'moment';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';
// import SearchIcon from '@mui/icons-material/Search';
// import FilterListIcon from '@mui/icons-material/FilterList';

// export const AllDevelopersMain = () => {
//   const [loading, setLoading] = useState(true);

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   const dispatch = useDispatch();

//   // States for filtering
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');

//   const run = async () => {
//     setLoading(true);
//     await dispatch(GetDevelopersData());
//     setLoading(false);
//   };

//   //get all developers data
//   useEffect(() => {
//     run();
//   }, []);

//   const resGetAll = useSelector((state) => state.AllDevelopers.Developers);
//   let AllDevelopers = Array.isArray(resGetAll?.data) ? resGetAll.data : [];

//   // Filtered developers based on search and filters
//   const filteredDevelopers = AllDevelopers.filter((developer) => {
//     const matchesSearch = developer.name?.toLowerCase().includes(searchTerm.toLowerCase());

//     // Date filtering options
//     const matchesDate =
//       dateFilter === 'all' ||
//       (dateFilter === 'today' && isToday(developer.createdAt)) ||
//       (dateFilter === 'week' && isThisWeek(developer.createdAt)) ||
//       (dateFilter === 'month' && isThisMonth(developer.createdAt));

//     return matchesSearch && matchesDate;
//   });

//   // Helper functions for date filtering
//   const isToday = (dateString) => {
//     const date = new Date(dateString);
//     const today = new Date();
//     return date.toDateString() === today.toDateString();
//   };

//   const isThisWeek = (dateString) => {
//     const date = new Date(dateString);
//     const today = new Date();
//     const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
//     const endOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 6));
//     return date >= startOfWeek && date <= endOfWeek;
//   };

//   const isThisMonth = (dateString) => {
//     const date = new Date(dateString);
//     const today = new Date();
//     return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
//   };

//   //========================================================

//   //clipboard copy channal id
//   const [open, setOpen] = useState(false);
//   const handleCopy = () => {
//     setOpen(true);
//     setTimeout(() => setOpen(false), 2000);
//   };

//   const [columns, setColumns] = useState([
//     { key: 'copyId', label: 'Copy Id', visible: true, width: 130 },
//     { key: 'name', label: 'Name', visible: true, width: 180 },
//     { key: 'date', label: 'Creation Date', visible: true, width: 160 },
//     { key: 'actions', label: 'Actions', visible: true, width: 160 },
//   ]);

//   const startResizing = (e, colIndex) => {
//     e.preventDefault();
//     const startX = e.clientX;
//     const startWidth = columns[colIndex].width;

//     const onMouseMove = (e) => {
//       const newWidth = Math.max(startWidth + e.clientX - startX, 60);
//       setColumns((prev) => {
//         const updated = [...prev];
//         updated[colIndex] = { ...updated[colIndex], width: newWidth };
//         return updated;
//       });
//     };

//     const onMouseUp = () => {
//       document.removeEventListener('mousemove', onMouseMove);
//       document.removeEventListener('mouseup', onMouseUp);
//     };

//     document.addEventListener('mousemove', onMouseMove);
//     document.addEventListener('mouseup', onMouseUp);
//   };

//   // Clear all filters
//   const clearFilters = () => {
//     setSearchTerm('');
//     setDateFilter('all');
//   };

//   return (
//     <Container className="startpage">
//       <Row style={{ width: '100%', marginTop: '20px' }}>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           <div className=" d-flex justify-content-between w-100 flex-wrap ">
//             <div>
//               <Link
//                 to={
//                   userlogin?.data?.role === 'Admin'
//                     ? '/AllLeadsForAdmin'
//                     : userlogin?.data?.role === 'Marketer'
//                       ? '/ALLLeadsForMarketer'
//                       : userlogin?.data?.role === 'Accountant'
//                         ? '/LeadsForAccountant'
//                         : '/Dashboard'
//                 }
//                 style={{ textDecoration: 'none', color: '#102dff' }}
//               >
//                 <span style={{ fontWeight: 'bold' }}>Home</span>
//               </Link>
//               <KeyboardDoubleArrowRightIcon />
//               <span style={{ color: '#666' }}>All Developers</span>
//             </div>
//           </div>

//           <div className="w-100 d-flex justify-content-end">
//             <Link to={`/AddDeveloper`}>
//               <div
//                 className="public-color btn btn-success icon-plus addnewclientbtn my-2"
//                 style={{ background: '#102dff' }}
//               >
//                 <AddIcon />
//                 Add Developer
//               </div>
//             </Link>
//           </div>

//           {/* 🔍 Filter Section */}
//           <Box
//             sx={{
//               mb: 3,
//               p: 2,
//               border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//               borderRadius: 2,
//               backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f9f9f9',
//             }}
//           >
//             <div className="d-flex align-items-center mb-2">
//               <FilterListIcon sx={{ mr: 1, color: '#102dff' }} />
//               <h6 style={{ margin: 0, color: mode === 'dark' ? '#90caf9' : '#666' }}>
//                 Filter Developers
//               </h6>
//             </div>

//             <div className="row g-2">
//               <div className="col-md-12">
//                 <TextField
//                   fullWidth
//                   size="small"
//                   placeholder="Search by developer name..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: '#666', mr: 1 }} />,
//                   }}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: mode === 'dark' ? '#252525' : '#fff',
//                     },
//                   }}
//                 />
//               </div>

//               {/* <div className="col-md-4"> */}
//               {/* <TextField
//                   select
//                   fullWidth
//                   size="small"
//                   label="Filter by Date"
//                   value={dateFilter}
//                   onChange={(e) => setDateFilter(e.target.value)}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: mode === 'dark' ? '#252525' : '#fff',
//                     }
//                   }}
//                 >
//                   <MenuItem value="all">All Dates</MenuItem>
//                   <MenuItem value="today">Today</MenuItem>
//                   <MenuItem value="week">This Week</MenuItem>
//                   <MenuItem value="month">This Month</MenuItem>
//                 </TextField> */}
//               {/* </div> */}

//               {/* <div className="col-md-2">
//                 <button 
//                   className="btn btn-outline-secondary"
//                   onClick={clearFilters}
//                   style={{ width: '100%', height: '40px',backgroundColor:"#102dff",color:"white" }}
//                 >
//                   Clear
//                 </button>
//               </div> */}
//             </div>

//             {/* Results count */}
//             <div className="mt-2">
//               <small style={{ color: mode === 'dark' ? '#90caf9' : '#666' }}>
//                 Showing {filteredDevelopers.length} of {AllDevelopers.length} developers
//                 {searchTerm && ` • Search: "${searchTerm}"`}
//                 {dateFilter !== 'all' &&
//                   ` • Date: ${dateFilter === 'today' ? 'Today' : dateFilter === 'week' ? 'This Week' : 'This Month'}`}
//               </small>
//             </div>
//           </Box>

//           <div style={{ marginBottom: '10px' }}>
//             {columns.map((col, index) => (
//               <label key={col.key} style={{ marginRight: '15px' }}>
//                 <input
//                   type="checkbox"
//                   checked={col.visible}
//                   onChange={() => {
//                     const updated = [...columns];
//                     updated[index].visible = !updated[index].visible;
//                     setColumns(updated);
//                   }}
//                 />
//                 {col.label}
//               </label>
//             ))}
//           </div>

//           <div
//             style={{
//               overflowX: 'auto',
//               width: '100%',
//               marginTop: '20px',
//               borderRadius: '15px',
//             }}
//           >
//             <Table
//               size="sm"
//               responsive
//               style={{
//                 minWidth: isExtraSmallScreen ? '800px' : '100%',
//                 textAlign: 'center',
//                 color: mode === 'dark' ? '#90caf9' : '#666',
//                 backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                 borderCollapse: 'separate',
//                 borderSpacing: '0',
//                 borderRadius: '15px',
//                 overflow: 'hidden',
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     whiteSpace: 'nowrap',
//                     height: '20px',
//                     fontSize: '14px',
//                     background:
//                       mode === 'dark'
//                         ? 'linear-gradient(to right, #1a1a1a, #2a2a2a)'
//                         : 'linear-gradient(to right, #0F7687, #0d5c6b)',
//                     color: mode === 'dark' ? '#666' : 'white',
//                     position: 'sticky',
//                     top: 0,
//                     zIndex: 1,
//                     borderBottom: mode === 'dark' ? '1px solid #90caf9' : '2px solid #666',
//                   }}
//                 >
//                   {columns
//                     .filter((col) => col.visible)
//                     .map((col, index) => (
//                       <th
//                         key={col.key}
//                         style={{
//                           position: 'relative',
//                           color: '#666',
//                           minWidth: `${col.width}px`,
//                           maxWidth: `${col.width}px`,
//                           whiteSpace: 'nowrap',
//                         }}
//                       >
//                         {col.label}
//                         <div
//                           onMouseDown={(e) => startResizing(e, index)}
//                           style={{
//                             position: 'absolute',
//                             right: 0,
//                             top: 0,
//                             height: '100%',
//                             width: '5px',
//                             cursor: 'col-resize',
//                             userSelect: 'none',
//                           }}
//                         />
//                       </th>
//                     ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={columns.length} className="text-center py-5">
//                       <Spinner animation="border" style={{ color: '#102dff' }} />
//                     </td>
//                   </tr>
//                 ) : filteredDevelopers.length ? (
//                   filteredDevelopers.map((dev, index) => (
//                     <tr key={index} style={{ cursor: 'pointer' }}>
//                       {columns
//                         .filter((col) => col.visible)
//                         .map((col) => {
//                           switch (col.key) {
//                             case 'copyId':
//                               return (
//                                 <td key={col.key}>
//                                   <CopyToClipboard text={dev._id} onCopy={handleCopy}>
//                                     <div>
//                                       <ContentCopyIcon style={{ color: '#102dff' }} />
//                                     </div>
//                                   </CopyToClipboard>
//                                   <Snackbar open={open} autoHideDuration={2000}>
//                                     <Alert severity="success">Copy Done</Alert>
//                                   </Snackbar>
//                                 </td>
//                               );
//                             case 'name':
//                               return (
//                                 <td
//                                   key={col.key}
//                                   style={{ color: mode === 'dark' ? '#ccc' : '#666' }}
//                                 >
//                                   {dev.name}
//                                 </td>
//                               );
//                             case 'date':
//                               return (
//                                 <td
//                                   key={col.key}
//                                   style={{ color: mode === 'dark' ? '#ccc' : '#666' }}
//                                 >
//                                   {dev.createdAt
//                                     ? moment(dev.createdAt).format('DD/MM/YYYY h:mm A')
//                                     : null}
//                                 </td>
//                               );
//                             case 'actions':
//                               return (
//                                 <td
//                                   key={col.key}
//                                   className="d-flex justify-content-center flex-wrap"
//                                 >
//                                   <DeveloperTable developers={dev} alldevelopers={run} />
//                                 </td>
//                               );
//                             default:
//                               return null;
//                           }
//                         })}
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={columns.length} className="text-center py-5">
//                       No Developers Found matching your filters
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

































// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
import { DeveloperTable } from './DeveloperTable';
import { useSidebarWidth } from '../Utility/useSidebarWidth';
// import './AllProjects.css'; // نفس الـ CSS

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconFilter  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCopy    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconPlus    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconDev     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IconBadge   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>;
const IconTrend   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;

/* ─── Helpers ────────────────────────────────────────────────────────────── */
const EXPANDED_WIDTH = 242;

const isToday = (d) => {
  const date = new Date(d); const today = new Date();
  return date.toDateString() === today.toDateString();
};
const isThisWeek = (d) => {
  const date = new Date(d); const now = new Date();
  const start = new Date(now); start.setDate(now.getDate() - now.getDay());
  const end   = new Date(start); end.setDate(start.getDate() + 6);
  return date >= start && date <= end;
};
const isThisMonth = (d) => {
  const date = new Date(d); const now = new Date();
  return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
};

/* ─── Component ──────────────────────────────────────────────────────────── */
export const AllDevelopersMain = () => {
  const dispatch = useDispatch();
  const theme    = useTheme();
  const mode     = theme.palette.mode;

  const [loading,      setLoading]      = useState(true);
  const [searchTerm,   setSearchTerm]   = useState('');
  const [dateFilter,   setDateFilter]   = useState('all');
  const [showFilter,   setShowFilter]   = useState(false);
  const [page,         setPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [copyOpen,     setCopyOpen]     = useState(false);
  const [userlogin,    setUserlogin]    = useState(null);
  // const [sidebarWidth, setSidebarWidth] = useState(EXPANDED_WIDTH);
  const sidebarWidth = useSidebarWidth();

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  // useEffect(() => {
  //   const h = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', h);
  //   return () => window.removeEventListener('sidebarResized', h);
  // }, []);

  const run = async () => {
    setLoading(true);
    await dispatch(GetDevelopersData());
    setLoading(false);
  };
  useEffect(() => { run(); }, []);

  const resGetAll      = useSelector((state) => state.AllDevelopers.Developers);
  const AllDevelopers  = Array.isArray(resGetAll?.data) ? resGetAll.data : [];

  /* filter */
  const filtered = AllDevelopers.filter((dev) => {
    const matchSearch = !searchTerm || dev.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchDate =
      dateFilter === 'all'   ? true :
      dateFilter === 'today' ? isToday(dev.createdAt) :
      dateFilter === 'week'  ? isThisWeek(dev.createdAt) :
      dateFilter === 'month' ? isThisMonth(dev.createdAt) : true;
    return matchSearch && matchDate;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  /* stats */
  const thisMonth   = AllDevelopers.filter(d => isThisMonth(d.createdAt)).length;
  const newestDev   = AllDevelopers.length
    ? AllDevelopers.reduce((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? a : b)
    : null;

  /* home link */
  const homeLink = userlogin?.data?.role === 'Admin'      ? '/AllLeadsForAdmin'
                 : userlogin?.data?.role === 'Marketer'   ? '/ALLLeadsForMarketer'
                 : userlogin?.data?.role === 'Accountant' ? '/LeadsForAccountant'
                 : '/Dashboard';

  /* page numbers */
  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (page >= totalPages - 3) {
      pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
    }
    return pages;
  };

  /* ── render ── */
  return (
    <>
      <div
        className={`ap-shell ${mode}`}
        style={{
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
          height: 'calc(100vh - 50px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '50px',
        }}
      >

        {/* ─── Breadcrumbs ─── */}
        <section style={{ padding: '20px 28px 0', marginBottom: '-8px', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
            <Link
              to={homeLink}
              style={{ textDecoration: 'none', color: mode === 'dark' ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans', sans-serif" }}
            >
              Home
            </Link>
            <span style={{ color: mode === 'dark' ? '#4b5563' : '#d1d5db' }}>/</span>
            <span style={{ color: mode === 'dark' ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
              Developers
            </span>
          </div>
        </section>

        {/* ─── Stats ─── */}
        <section className="ap-stats" style={{ padding: '24px 28px 0', flexShrink: 0 }}>

          {/* card 1 */}
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">TOTAL DEVELOPERS</div>
              <div className="ap-stat-value">{AllDevelopers.length}</div>
              <div className="ap-stat-badge green">↑ Active in system</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconDev /></div>
          </div>

          {/* card 2 */}
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">ADDED THIS MONTH</div>
              <div className="ap-stat-value large">{thisMonth}</div>
              <div className="ap-stat-badge green">Last 30 days</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconBadge /></div>
          </div>

          {/* card 3 — dark */}
          <div className="ap-stat-card dark-card">
            <div>
              <div className="ap-stat-label white">LATEST DEVELOPER</div>
              <div className="ap-stat-value white" style={{ fontSize: 18, marginTop: 4 }}>
                {newestDev?.name || '—'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                <span className="ap-badge-pill">MOST RECENT</span>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>
                  {newestDev ? moment(newestDev.createdAt).format('MMM DD, YYYY') : ''}
                </span>
              </div>
            </div>
            <div className="ap-stat-icon dark-icon"><IconTrend /></div>
          </div>
        </section>

        {/* ─── Table Section ─── */}
        <section
          className="ap-table-section"
          style={{
            margin: '24px 28px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minHeight: 0,
          }}
        >

          {/* header */}
          <div className="ap-table-header" style={{ flexShrink: 0 }}>
            <div>
              <div className="ap-table-title-label">REAL ESTATE</div>
              <div className="ap-table-title">DEVELOPERS</div>
            </div>
            <div className="ap-table-actions">
              <div className="ap-search-inline">
                <IconSearch />
                <input
                  placeholder="Search developers by name…"
                  value={searchTerm}
                  onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                />
              </div>
              <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                <IconFilter /> Filter
              </button>
              <Link to="/AddDeveloper" style={{ textDecoration: 'none' }}>
                <button className="ap-create-btn"><IconPlus /> Add Developer</button>
              </Link>
            </div>
          </div>

          {/* filter row */}
          {showFilter && (
            <div className="ap-filter-row" style={{ flexShrink: 0 }}>
              <select value={dateFilter} onChange={(e) => { setDateFilter(e.target.value); setPage(1); }}>
                <option value="all">All Dates</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
              </select>
              <button
                className="ap-clear-btn"
                onClick={() => { setSearchTerm(''); setDateFilter('all'); setPage(1); }}
              >
                Clear
              </button>
            </div>
          )}

          {/* ✅ Table wrap — scroll داخلي */}
          <div className="ap-table-wrap" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
            <table className="ap-table">
              <thead>
                <tr>
                  <th style={{ width: 40, position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>
                    <input type="checkbox" className="ap-checkbox" />
                  </th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>DEVELOPER NAME</th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>CREATED DATE</th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={4} className="ap-empty">
                      <div className="ap-spinner" />
                      <span>Loading developers…</span>
                    </td>
                  </tr>
                ) : pageItems.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="ap-empty">
                      <IconSearch />
                      <p>No developers found</p>
                    </td>
                  </tr>
                ) : (
                  pageItems.map((dev, i) => (
                    <tr key={dev._id || i} className="ap-row">
                      <td><input type="checkbox" className="ap-checkbox" /></td>

                      <td>
                        <div className="ap-project-cell">
                          <div className="ap-project-thumb">
                            {dev.name?.slice(0, 2).toUpperCase() || 'DV'}
                          </div>
                          <span className="ap-project-name">{dev.name || '—'}</span>
                        </div>
                      </td>

                      <td className="ap-cell-muted" style={{ fontSize: 13 }}>
                        {dev.createdAt ? moment(dev.createdAt).format('MMM DD, YYYY') : '—'}
                      </td>

                      <td>
                        <div className="ap-actions">
                          <CopyToClipboard
                            text={dev._id}
                            onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}
                          >
                            <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
                          </CopyToClipboard>
                          <DeveloperTable developers={dev} alldevelopers={run} />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ✅ PAGINATION — sticky في أسفل الجدول */}
          {filtered.length > 0 && (
            <div
              className="ap-pagination"
              style={{
                position: 'sticky',
                bottom: 0,
                zIndex: 5,
                flexShrink: 0,
                backgroundColor: mode === 'dark' ? '#1a1a2e' : '#ffffff',
                borderTop: `1px solid ${mode === 'dark' ? '#2a2a45' : '#e8eaf0'}`,
                boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
              }}
            >
              <div className="ap-pagination-info">
                <span>Items per page:</span>
                <select
                  className="ap-page-select"
                  value={itemsPerPage}
                  onChange={(e) => { setItemsPerPage(Number(e.target.value)); setPage(1); }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span>
                  Showing{' '}
                  <strong>{(page - 1) * itemsPerPage + 1}–{Math.min(page * itemsPerPage, filtered.length)}</strong>
                  {' '}of{' '}
                  <strong>{filtered.length}</strong> developers
                </span>
              </div>

              <div className="ap-pagination-btns">
                <button className="ap-pag-btn" onClick={() => setPage(1)} disabled={page === 1}>⟨|</button>
                <button className="ap-pag-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>‹</button>

                {buildPageNumbers().map((n, idx) =>
                  n === '...'
                    ? <span key={`e-${idx}`} className="ap-pag-ellipsis">…</span>
                    : <button
                        key={n}
                        className={`ap-pag-btn ${page === n ? 'active' : ''}`}
                        onClick={() => setPage(n)}
                      >{n}</button>
                )}

                <button className="ap-pag-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>›</button>
                <button className="ap-pag-btn" onClick={() => setPage(totalPages)} disabled={page === totalPages}>|⟩</button>
              </div>
            </div>
          )}
        </section>

        {/* Footer */}
        <footer className="ap-footer" style={{ padding: '16px 28px', marginTop: 'auto', flexShrink: 0 }}>
          <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
        </footer>

      </div>

      <Snackbar open={copyOpen} autoHideDuration={2000}>
        <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};

